import { render, staticRenderFns } from "./IntegracaoIcon.vue?vue&type=template&id=432129b3"
import script from "./IntegracaoIcon.vue?vue&type=script&lang=js"
export * from "./IntegracaoIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports